import React from 'react'

import Biote_cobalt from '../../images/biote_cobalt.png'

const First_pane = () => {
  return (
   
       <div className=''>
           <div
        
        style={{ 
        backgroundImage: `-webkit-linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)), url(${Biote_cobalt})`,
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)), url(${Biote_cobalt})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        paddingBottom: '50px',
        paddingTop: '100px',
        height: '100vh'
        }}
    
    
    >


        <div className='uk-container'>

            <div className='uk-grid' data-uk-grid>
                <div className='uk-width-1-2@s'>
                    
           <h1 className='light header1 uk-margin-xlarge-top' uk-scrollspy="cls: uk-animation-slide-right; repeat: true">Valley Court</h1>
      
           <h5 className='light uk-margin-medium-top'
            uk-scrollspy="cls: uk-animation-fade; repeat: true">
              
Plot Number: Plot 678, Cad Zone C04,Dape (Lifecamp) District              
Plot Title:    Certificate of Occupancy <br/>
Plot Size:    1,117.41M <br/>
Land Use:    Residential<br/>
Mode of Land Acquisition:     Joint Venture<br/>
Total No. Of Housing Units:    12 Units<br/>
Project Start Date:    August 2024<br/>

              
              </h5>
                </div>

                <div className='uk-width-1-2@s'>

                </div>
            </div>

    




        </div>
       
    </div>


  <div className='uk-container uk-margin-large-top' >
         <h3>The Promise</h3>
        <div className='uk-width-1-1'>
            <img src={Biote_cobalt} />
        </div>
      </div>

  
      




    </div>



  )
}

export default First_pane